var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svg-parser",domProps:{"innerHTML":_vm._s(_vm.mnemonic)}})
}
var staticRenderFns = []

export { render, staticRenderFns }